module.exports = __webpack_public_path__ + "static/mario_die-44b74c2c2cf819e7774a7df3682e0515.wav";